





























interface Pagination {
  currentPage: number;
  firstPageUrl: string;
  from: number;
  lastPage: number;
  lastPageUrl: string;
  nextPageUrl: string | null;
  path: string;
  perPage: number;
  prevPageUrl: string | null;
  to: number;
  total: number;
}
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Paginater extends Vue {
  @Prop({ type: Object, required: false }) private pagination!: Pagination;

  mounted(): void {
    // put something
  }

  get pageItem(): number[] {
    const pages: number[] = [];
    let i = this.pagination.from;
    const len: number = this.pagination.lastPage;
    for (i = 0; i < len; i++) {
      pages[i] = i + 1;
    }
    return pages;
  }

  movePage(page: number | string): void {
    this.$emit("movePage", page);
  }
}
